import _ from "underscore";
import vSelect from "vue-select";
import AccountManagerForm from "../accountmanager/AccountManagerForm";
import Auth from "@/helpers/middleware";
import { Cliente } from "@/views/operaciones/automotoras/models/cliente.model";
import sysMsgs from "@/helpers/system.message";
import clientesServices from "@/services/dealers.services";
import dataServices from "@/services/dataService.services";
import memberProfileServices from "@/services/memberprofile.services"
import globalServices from "@/services/globals.services";
import validation from "@/helpers/validations";
import utils from "@/helpers/utils";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import { FileUpload } from "../../../../shared/models/file-upload.model";
import cancelButtonImageFachada from "../cancelButtonImageFachada";
import slotAdditionalEmail from "../slotAdditionalEmail";

export default {
    name: "Automotoras",
    components: {
        vSelect,
        AccountManagerForm,
        Cropper,
        cancelButtonImageFachada,
        slotAdditionalEmail,
    },
    data() {
        return {
            URLRegister: process.env.VUE_APP_CHILEAUTOS_SITE +
                "/membership/register?userType=Dealer&returnUrl=%2FRedirectMB%2FNewDealers",
            error: false,
            tabIndex: 0,
            deletingProduct: false,
            emailValid: null,
            selectedPlan: {
                premium: 0,
                code: "0",
                name: "",
                products: [],
                quantity: 0,
                active: true,
            },
            actions: Auth.getActions(this.$route.name),
            selectedCity: 0,
            selectedComuna: 0,
            selectedRegion: 0,
            loading: false,
            clients: [],
            planes: [],
            newPhone: "",
            clientstmp: [],
            regiones: [],
            ciudades: [],
            comunas: [],
            client_: null,
            client: null,
            isCp: false,
            isNetsuiteActive: true,
            notFound: false,
            ProductDetails: "0",
            selectedProductDetails: false,
            optionDetails: 0,
            showForm: false,
            clientActive: true,
            controller: {
                title: "Automotoras",
                mainRouter: "/intranetca/operaciones/automotoras",
            },
            options: {
                selectData: true,
            },
            newAdditionalEmail: {
                idAdditionalEmail: 0,
                additionalEmail: "",
                copyTypeEmail: "AddCC",
                action: "",
                index: "",
            },
            tempListAdditionalEmails: [],
            editAdditionalEmail: {
                index: null,
                showEdit: false,
                item: {
                    idAdditionalEmail: 0,
                    copyEmail: "",
                    copyType: "AddCC",
                    action: "",
                    index: "",
                },
            },
            oldAdditionalEmail: "",
            imageFachada: {
                src: "",
                type: "",
                extension: "",
            },
            showCropFachada: false,
            formDataImageFachada: FormData,
            base64ImageFachada: "",
            showCardPreviewCropImageFachada: false,
            showImage: false,
            paginate: ["tempListAdditionalEmails"],
            additionalEmailsPerPage: 4,
            hasAccount: false,
            newEmailAccount: null
        };
    },

    filters: {
        formatDate(str) {
            return utils.formatDateTime(str);
        },
    },
    watch: {
        client_: {
            deep: true,
            handler(data) {
                if (data == null) {
                    this.showForm = false;
                    return false;
                } else {
                    this.showForm = true;
                    this.getDealer(data);
                    this.tabIndex = 0;
                }
            },
        },
        "client.plan.code": {
            deep: true,
            handler(data) {
                if (data != 0) {
                    this.showPlanDetails(data);
                    return false;
                } else {
                    this.selectedPlan = {
                        premium: 0,
                        code: "0",
                        name: "",
                        products: [],
                        quantity: 0,
                        active: false,
                    };
                }
            },
        },
        "client.active": {
            deep: true,
            handler(data) {
                this.clientActive = data ? data : this.clientActive;
            },
        },
        ProductDetails: {
            deep: true,
            handler(data) {
                if (data != 0) {
                    if (
                        this.client.plan.products.filter(
                            (item) => item.code == data.code && !data.multiple
                        ).length > 0
                    ) {
                        this.optionDetails = this.client.plan.products
                            .find((item) => item.code == data.code)
                            .details.map((a) => a.code)[0];
                    }
                    return false;
                }
            },
        },
        optionDetails: {
            deep: true,
            handler(data) {
                if (data && data != 0 && !this.ProductDetails.multiple) {
                    let productIndex = this.client.plan.products.findIndex(
                        (p) => p.code == this.ProductDetails.code
                    );

                    if (productIndex > -1) {
                        this.client.plan.products[productIndex].details = [{
                            ...this.client.plan.products[productIndex].details[0],
                            ...this.ProductDetails.details.find((d) => d.code == data),
                        }, ];
                    } else {
                        let details = this.ProductDetails.details.find(
                            (d) => d.code == data
                        );
                        this.client.plan.products.push({
                            name: this.ProductDetails.name,
                            code: this.ProductDetails.code,
                            details: [details],
                        });
                    }

                    return false;
                }
                /* else {
                         let productIndex = this.client.plan.products.findIndex(
                           p => p.code == this.ProductDetails.code
                         );
                         if (productIndex > -1) {
                           //this.client.plan.products[productIndex].details = [...[]];
                         }
                       }*/
            },
        }
    },
    computed: {
        validatePhones() {
            return this.client.phones.length > 0;
        },
        validateNewPhone() {
            return this.newPhone.length > 8 && validation.isNumeric(this.newPhone);
        },
        isRut() {
            if (this.client.rut) {
                return validation.rut.isValid(this.client.rut);
            }
            return false;
        },
        _isMultipleSelected() {
            let _self = this;
            return (
                _self.ProductDetails.details.filter(
                    (item) => _self.optionDetails == item.code
                ).length == 0
            );
        },
        filterAdditionalEmails() {
            const filtered = this.tempListAdditionalEmails;
            return filtered;
        },
    },
    created() {
        this.getPlanes();
        this.getRegiones();
        this.$validator.localize("es");
        //this.getAllDealers();
        this.nuevoCliente();
    },
    mounted() {},
    methods: {
        handlerNetsuite(event) {
            this.isNetsuiteActive = event;
        },
        initializeImageFachada() {
            this.imageFachada = {
                src: "",
                type: "",
                extension: "",
            };
            this.showCropFachada = false;
            this.formDataImageFachada = new FormData();
            this.base64ImageFachada = "";
            this.showCardPreviewCropImageFachada = false;
        },
        uploadImageFachada() {
            this.loading = true;
            const fileUpload = new FileUpload();
            fileUpload.file = this.formDataImageFachada;
            fileUpload.typePath = "fachada";
            fileUpload.urlFileExist = this.client.foto_grande;

            clientesServices.general
                .uploadFachada(fileUpload)
                .then((c) => {
                    const {
                        data: { data },
                    } = c;
                    this.client.foto_grande = data.url;
                    this.client.user_action = Auth.getUser() ? Auth.getUser().email : "";
                    this.saveDealer();
                })
                .catch(({ response: { data: { error } } }) => {
                    this.initializeImageFachada();
                    sysMsgs.getMessage(
                        `Hubo un inconveniente para actualizar imagen de fachada. Motivo: ${error}`,
                        "error"
                    );
                    this.loading = false;
                })
                .finally(() => {
                    this.initializeImageFachada();
                });
        },
        cropImageFachada() {
            const result = this.$refs.cropper.getResult();
            const base64CropFachada = result.canvas.toDataURL(this.imageFachada.type);
            this.base64ImageFachada = "";
            this.base64ImageFachada = base64CropFachada;

            fetch(base64CropFachada)
                .then((res) => res.blob())
                .then((blob) => {
                    const file = new File(
                        [blob],
                        `m_${this.client.identifier}.${this.imageFachada.extension}`, { type: this.imageFachada.type }
                    );
                    if (file.size > 500000) {
                        sysMsgs.getMessage(
                            "El peso del corte de la imagen supera los 500 kilobytes.",
                            "error"
                        );
                        this.initializeImageFachada();
                    } else {
                        this.formDataImageFachada = new FormData();
                        this.formDataImageFachada.append("file", file);
                    }
                    this.formDataImageFachada = new FormData();
                    this.formDataImageFachada.append("file", file);
                })
                .catch((error) => {
                    this.initializeImageFachada();
                    sysMsgs.getResponseMessage(error.response);
                })
                .finally(() => {
                    this.showCropFachada = false;
                });
        },
        selectImageFachada(event) {
            this.showCropFachada = false;
            this.showCardPreviewCropImageFachada = false;
            const { files } = event.target;
            if (files && files[0]) {
                if (this.imageFachada.src) {
                    URL.revokeObjectURL(this.imageFachada.src);
                }

                if (files[0].name.endsWith(".jpg")) {
                    const blob = URL.createObjectURL(files[0]);

                    this.imageFachada = {
                        src: blob,
                        type: files[0].type,
                        extension: files[0].name.split(".")[1],
                    };
                    this.showCropFachada = true;
                    this.showCardPreviewCropImageFachada = true;
                } else {
                    sysMsgs.getMessage(
                        "Solo se permiten imagenes con extensión jpg",
                        "error"
                    );
                }

                this.$refs.file.value = null;
            }
        },
        saveDealer() {
            const _this = this;
            let post = _this.client;
            clientesServices.general
                .saveDealer(post)
                .then((response) => {
                    _this.loading = false;
                    _this.error = false;
                    _this.client = response.data.dealer;
                    _this.clientActive = _this.client.active;
                    sysMsgs.getMessage(
                        "Datos actualizados con imagen de fachada",
                        "success"
                    );
                })
                .catch((error) => {
                    if (error.response.data && error.response.data.status == 500) {
                        sysMsgs.getDialog(
                            "Los datos fueron parcialmente guardados. Por favor, contacte al Departamento de TI.",
                            "warning",
                            "Error al ejecutar servicio externo."
                        );
                        return;
                    }
                    sysMsgs.getResponseMessage(error.response);
                    _this.error = true;
                })
                .finally(() => {
                    _this.loading = false;
                });
        },
        cancelSubmit() {
            this.showForm = false;
            this.hasAccount = false;
        },
        showPlanDetails(id) {
            this.selectedPlan = this.planes.find((plan) => plan.code == id);
        },
        getDealer(value) {
            if (!value) return;

            this.showImage = false;
            this.optionDetails = 0;
            this.ProductDetails = 0;
            this.initializeNewAdditionalEmail();
            this.initializeEditAdditionalEmail();
            this.tempListAdditionalEmails = [];
            this.paginate.tempListAdditionalEmails.list = [];
            this.paginate.tempListAdditionalEmails.page = 0;
            this.showCardPreviewCropImageFachada = false;

            this.loading = true;
            clientesServices.general
                .getDealer(value.cod_cliente)
                .then((response) => {
                    dataServices.getSellerDetails(value.cod_cliente).then((dsResponse) => {
                        this.isCp = dsResponse && dsResponse.Products && dsResponse.Products.length > 0 &&
                            dsResponse.Products.findIndex(p => p.Code === 'CP') > -1 &&
                            dsResponse.Products.findIndex(p => p.Code === 'GLOBALINVENTORY') === -1 &&
                            dsResponse.Products.findIndex(p => p.Code === 'INTSVC') === -1;
                    }).finally(() => {
                        this.loading = false;
                        this.showImage = true;
                    });
                    this.client = response.data;
                    this.tempListAdditionalEmails = response.data.additionalEmails;
                    this.selectedRegion = this.client.state_id;
                    this.selectedCity = this.client.city_id;
                    this.selectedComuna = this.client.comuna;
                    this.clientActive = this.client.active;
                    this.getCiudades();
                })
                .catch((error) => {
                    sysMsgs.getResponseMessage(error.response);
                });

        },
        setList(search, loading) {
            if (search.toString().trim().length > 0) {
                this.clientstmp = _.filter(this.clients, (filter) => {
                    return (
                        filter.nombre_fantasia
                        .toString()
                        .toLowerCase()
                        .indexOf(search.toString().toLowerCase()) > -1 ||
                        filter.cod_cliente.toString() == search.toString()
                    );
                });
            } else {
                this.clientstmp = this.clients;
            }
        },

        getAllDealers() {
            this.loading = true;
            clientesServices.general
                .getAll()
                .then((response) => {
                    this.clients = response.data.dealers;
                    this.clientstmp = this.clients;
                })
                .catch((error) => {
                    sysMsgs.getResponseMessage(error.response);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getPlanes() {
            clientesServices.general
                .getPlanes()
                .then((response) => {
                    this.planes = response.data.plans.filter((plan) => plan.active);
                })
                .catch((error) => {
                    sysMsgs.getResponseMessage(error.response);
                });
        },
        setDealer() {
            this.initializeNewAdditionalEmail();
            this.initializeEditAdditionalEmail();
            if (!this.validatePhones) {
                sysMsgs.getMessage("Agrega uno o más teléfonos.", "error");
                return false;
            }

            if (!this.isRut) {
                sysMsgs.getMessage("El RUT ingresado es incorrecto", "error");
                return false;
            }

            if (this.client.plan.code == 0) {
                sysMsgs.getMessage(
                    "Debe seleccionar un Plan antes de guardar cambios",
                    "error"
                );
                return false;
            }

            this.$validator.validate().then((valid) => {
                if (!valid) {
                    sysMsgs.getMessage("Corrige los campos inválidos.", "error");
                    return false;
                }

                this.client.state_id = this.selectedRegion;
                this.client.city_id = this.selectedCity;
                this.client.comuna = this.selectedComuna;
                this.client.user_action = Auth.getUser() ? Auth.getUser().email : "";

                const _this = this;
                const warningMessage = this.client.active ?
                    "Confirma esta acción" :
                    "Al desactivar la automotora, se deshabilitarán sus avisos. ¿Desea continuar?";
                sysMsgs.getConfirm(warningMessage, "").then((result) => {
                    if (result.value) {
                        _this.loading = true;
                        let post = _this.client;

                        clientesServices.general
                            .saveDealer(post)
                            .then((response) => {
                                _this.loading = false;
                                _this.error = false;
                                _this.client = response.data.dealer;
                                _this.clientActive = _this.client.active;

                                _this.tempListAdditionalEmails = [];
                                _this.tempListAdditionalEmails =
                                    response.data.dealer.additionalEmails;
                                _this.paginate.tempListAdditionalEmails.page = 0;

                                sysMsgs.getMessage("Datos guardados", "success");
                                this.hasAccount = false;
                            })
                            .catch((error) => {
                                if (error.response.data && error.response.data.status == 500) {
                                    sysMsgs.getDialog(
                                        "Los datos fueron parcialmente guardados. Por favor, contacte al Departamento de TI.",
                                        "warning",
                                        "Error al ejecutar servicio externo."
                                    );
                                    return;
                                }
                                sysMsgs.getResponseMessage(error.response);
                                _this.error = true;
                            })
                            .finally(() => {
                                _this.loading = false;
                            });
                    }
                });
            });
        },
        removeProduct(idDetail, codeProduct, index) {
            const _this = this;
            const clientTmp = this.client;

            sysMsgs
                .getConfirm(
                    "El cambio se hará efectivo al instante sin necesidad de guardar.",
                    "warning",
                    "¿Eliminar producto?"
                )
                .then((result) => {
                    if (result.value) {
                        if (index != null && index > -1) {
                            _this.client.plan.products
                                .find((item) => item.code == codeProduct)
                                .details.splice(index, 1);
                            _this.optionDetails = "";
                            return false;
                        }

                        _this.deletingProduct = true;
                        clientesServices.general
                            .removeDealerProduct(_this.client.id, idDetail)
                            .then((response) => {
                                _this.deletingProduct = false;
                                _this.error = false;

                                this.optionDetails = 0;
                                this.ProductDetails = 0;

                                if (
                                    clientTmp.plan.products.filter(
                                        (item) => item.details && item.details.length > 0
                                    ).length > 0
                                ) {
                                    let productIndex = clientTmp.plan.products.findIndex(
                                        (p) => p.code == codeProduct
                                    );
                                    let tmp = clientTmp.plan.products[
                                        productIndex
                                    ].details.filter((item) => item.id != idDetail);

                                    clientTmp.plan.products[productIndex].details = tmp;

                                    if (
                                        clientTmp.plan.products[productIndex].details.length == 0
                                    ) {
                                        clientTmp.plan.products.splice(productIndex, 1);
                                    }

                                    _this.client = {...clientTmp };
                                }
                                sysMsgs.getMessage(response.data.customMessage, "success");
                            })
                            .catch((error) => {
                                sysMsgs.getResponseMessage(error.response);
                                _this.error = true;
                            })
                            .finally(() => {
                                _this.deletingProduct = false;
                            });
                    }
                });
        },
        validateEmail(email) {
            return validation.isEmail(email);
        },
        nuevoCliente() {
            if (this.$route.query.id != null) {
                this.client = new Cliente();
                this.client.memberid = this.$route.query.id;
                this.client.sucursal_id = utils.ID();
                this.showForm = true;
                return;
            }
        },
        addPhone() {
            if (this.newPhone.trim().length > 8) {
                this.client.phones.push(this.newPhone);
                this.newPhone = "";
            }
        },
        deletePhone(index) {
            sysMsgs
                .getConfirm("Seguro que quiere eliminar el teléfono", "question")
                .then((response) => {
                    if (response.value) {
                        this.client.phones.splice(index, 1);
                    }
                });
        },
        getRegiones() {
            globalServices.filters.regiones().then((response) => {
                this.regiones = response.data;
            });

            if (this.client && this.client.city_id == 0) {
                this.client.city_id = 0;
            }
        },
        getCiudades() {
            if (this.selectedRegion == 0) {
                this.selectedCity = 0;
            }

            globalServices.filters.ciudades(this.selectedRegion).then((response) => {
                this.ciudades = response.data;
                this.getComunas();
            });
        },
        getComunas() {
            if (this.selectedCity == 0) {
                this.selectedComuna = 0;
            }
            globalServices.filters.comunas(this.selectedCity).then((response) => {
                this.comunas = response.data;
            });
        },
        getAll() {
            clientesServices.general
                .getAll()
                .then((response) => {
                    this.clients = response.data.dealers;
                    this.clientstmp = this.clients;
                })
                .catch((error) => {
                    sysMsgs.getResponseMessage(error.response);
                });
        },
        addProductDetail(item) {
            let _self = this;
            if (_self.client.plan) {
                if (
                    _self.client.plan.products.filter(
                        (item) => item.code == _self.ProductDetails.code
                    ).length > 0
                ) {
                    _self.client.plan.products
                        .find((item) => item.code == _self.ProductDetails.code)
                        .details.push(
                            _self.ProductDetails.details.find((data) => data.code == item)
                        );
                } else {
                    _self.client.plan.products.push({
                        code: _self.ProductDetails.code,
                        name: _self.ProductDetails.name,
                        description: _self.ProductDetails.description,
                        details: _self.ProductDetails.details.filter(
                            (data) => data.code == item
                        ),
                    });
                }
            }
        },
        userAlert() {
            alert("amiguito no");
        },
        addAdditionalEmail() {
            const isValid = this.validateAdditionalEmail(
                this.newAdditionalEmail.additionalEmail.trim()
            );
            if (isValid) {
                this.client.additionalEmails.push({
                    idAdditionalEmail: "0",
                    copyType: this.newAdditionalEmail.copyTypeEmail,
                    copyEmail: this.newAdditionalEmail.additionalEmail.trim(),
                    action: "insert",
                });
                this.tempListAdditionalEmails = this.client.additionalEmails;
                this.tempListAdditionalEmails = this.tempListAdditionalEmails.filter(
                    (x) => x.action !== "delete"
                );

                let ultimaPagina = 0;
                if (this.tempListAdditionalEmails.length > 1) {
                    ultimaPagina = Math.ceil(
                        this.tempListAdditionalEmails.length / this.additionalEmailsPerPage
                    );
                }
                this.paginate.tempListAdditionalEmails.page = ultimaPagina;
                this.initializeNewAdditionalEmail();
            }
        },
        deleteAdditionalEmail(item) {
            sysMsgs
                .getConfirm("Seguro que quiere eliminar el email adicional", "question")
                .then((response) => {
                    if (response.value) {
                        let index = this.tempListAdditionalEmails.indexOf(item);
                        if (
                            this.tempListAdditionalEmails[
                                index
                            ].idAdditionalEmail.toString() === "0"
                        ) {
                            let additionalEmail = this.client.additionalEmails.find(
                                (x) =>
                                x.copyType === item.copyType && x.copyEmail === item.copyEmail
                            );
                            if (additionalEmail !== undefined) {
                                this.client.additionalEmails = this.client.additionalEmails.filter(
                                    (x) => x !== additionalEmail
                                );
                            } else {
                                this.tempListAdditionalEmails[index].action = "delete";
                            }

                            this.tempListAdditionalEmails.splice(index, 1);
                        } else {
                            this.tempListAdditionalEmails[index].action = "delete";
                        }
                        this.tempListAdditionalEmails = this.tempListAdditionalEmails.filter(
                            (x) => x.action !== "delete"
                        );
                        this.initializeNewAdditionalEmail();
                    }
                });
        },
        updateAdditionalEmail(item, index) {
            this.initializeNewAdditionalEmail();
            this.oldAdditionalEmail = item.copyEmail;
            const additionalEmail = this.tempListAdditionalEmails.find(
                (x) =>
                x.idAdditionalEmail === item.idAdditionalEmail &&
                x.copyEmail === item.copyEmail
            );
            const indice = this.tempListAdditionalEmails.findIndex(
                (x) =>
                x.copyEmail.toLowerCase() === item.copyEmail.toLowerCase() &&
                x.copyType === item.copyType
            );

            this.initializeEditAdditionalEmail();
            this.editAdditionalEmail = {
                index: index,
                showEdit: true,
                item: additionalEmail,
            };
            this.editAdditionalEmail.item.index = indice === -1 ? item.index : indice;
            this.editAdditionalEmail.item.action =
                additionalEmail.idAdditionalEmail.toString() === "0" ?
                "insert" :
                "update";
        },
        initializeNewAdditionalEmail() {
            this.newAdditionalEmail = {
                idAdditionalEmail: 0,
                additionalEmail: "",
                copyTypeEmail: "AddCC",
                action: "",
                index: "",
            };
        },
        saveUpdateAdditionalEmail(item) {
            sysMsgs
                .getConfirm(
                    "Seguro que quiere modificar el email adicional",
                    "question"
                )
                .then((response) => {
                    if (response.value) {
                        if (item.idAdditionalEmail > 0) {
                            item.action = "update";
                        } else {
                            item.action = "insert";
                        }
                        this.initializeEditAdditionalEmail();
                    }
                });
        },
        existingEditAdditionalEmail(email, index) {
            if (email === undefined || email.trim().length === 0) {
                return false;
            }

            const actualEmail = this.tempListAdditionalEmails[index];
            const filter = this.tempListAdditionalEmails
                .filter((x) => x.action !== "delete" && x !== actualEmail)
                .find((x) => x.copyEmail.toLowerCase() === email.toLowerCase());
            if (filter !== undefined) {
                return true;
            }

            return false;
        },
        existingAdditionalEmail(email) {
            if (email === undefined || email.trim().length === 0) {
                return false;
            }

            const existingEmail = this.client.additionalEmails.find(
                (x) => x.copyEmail.toLowerCase() === email.toLowerCase()
            );

            if (existingEmail !== undefined) {
                return true;
            }
            return false;
        },
        validateAdditionalEmail(email) {
            return validation.isEmail(email);
        },
        initializeEditAdditionalEmail() {
            this.editAdditionalEmail = {
                index: null,
                showEdit: false,
                item: {
                    idAdditionalEmail: 0,
                    copyEmail: "",
                    copyType: "AddCC",
                    action: "update",
                },
            };
        },
        cancelEditAdditionalEmail(index) {
            this.tempListAdditionalEmails[index].copyEmail = this.oldAdditionalEmail;
            this.tempListAdditionalEmails[index].action =
                this.tempListAdditionalEmails[index].action === "update" ?
                "" :
                "insert";
            this.initializeEditAdditionalEmail();
        },
        isUrlImageFachada() {
            try {
                if (
                    this.client.foto_grande.includes(
                        this.client.identifier.toString().toLowerCase()
                    )
                ) {
                    return true;
                }
                return false;
            } catch (error) {
                return false;
            }
        },
        onTempAdditionalEmailsChange() {
            if (this.editAdditionalEmail.item.index !== undefined) {
                this.cancelEditAdditionalEmail(this.editAdditionalEmail.item.index);
            }
        },
        newDealer() {
            sysMsgs
                .getConfirm(
                    "¿El cliente tiene cuenta en chileautos.cl?",
                    "question",
                    "Nuevo registro",
                    "No",
                    "Si"
                )
                .then((result) => {
                    if (result.value) {
                        this.hasAccount = true;
                        this.newEmailAccount = null;
                        this.memberNotFound();
                        this.showForm = true;
                    } else if (result.dismiss == 'cancel') {
                        window.location.href = this.URLRegister;
                    }
                });
        },
        getMemberByEmail() {
            if (!this.validateEmail(this.newEmailAccount)) {
                this.memberNotFound();
                sysMsgs.getMessage(
                    `El email ingresado ${this.newEmailAccount} no es valido.`,
                    "error"
                );
                return;
            }

            this.loading = true;
            memberProfileServices.getMemberByEmail(this.newEmailAccount).then(result => {
                this.client.memberid = result.data.id;
                this.client.legal_name = (`${result.data.firstName.trim()} ${result.data.lastName}`).trim();
                this.client.user_email = this.newEmailAccount;
                this.client.leads_email = this.newEmailAccount;
            }).catch(error => {
                sysMsgs.getResponseMessage(error.response);
                this.memberNotFound();
            }).finally(() => {
                this.loading = false;
            })
        },
        memberNotFound() {
            this.client = new Cliente();
            this.client.sucursal_id = utils.ID();
        }
    },
    destroyed() {
        if (this.imageFachada.src) {
            URL.revokeObjectURL(this.imageFachada.src);
        }
    },
};